<template>
  <component
    :is="tagType"
    :class="classes"
    v-on="$listeners"
  >
    <VSpinner v-if="loading" />

    <slot v-else />
  </component>
</template>

<script>
import {
  VSpinner
} from '@c/base'

export default {
  components: {
    VSpinner
  },

  props: {
    tag: {
      type: String,
      default: 'button'
    },
    theme: {
      type: String,
      default: 'fill'
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {

    }
  },

  computed: {
    tagType () {
      let tag

      switch (this.tag) {
        case 'link':
          tag = 'a'

          break
        case 'router-link':
          tag = 'router-link'

          break
        default:
          tag = 'button'

          break
      }

      return tag
    },

    classes () {
      return [
        ...DEFAULT_CLASSES,
        ...THEMES[this.theme],
        this.$style[this.theme + '-transition']
      ]
    }
  }
}

const DEFAULT_CLASSES = [
  'rounded-sm',
  'font-bold',
  'text-center',
  'no-underline'
]

const THEMES = {
  link: [
    'border-none',
    'bg-transparent',
    'text-info-50',
    'hover:text-info-40',
    'hover:underline',
    'focus:outline-none'
  ],
  fill: [
    'border',
    'border-info-50',
    'bg-info-50',
    'text-white',
    'hover:bg-info-40',
    'py-3'
  ],
  outline: [
    'border',
    'border-info-50',
    'bg-transparent',
    'text-info-50',
    'hover:border-info-40',
    'hover:text-info-40',
    'py-3'
  ]
}
</script>

<style module>
.fill-transition {
  transition-duration: 0.3s;
  transition-property: background-color;
  transition-timing-function: ease;
}

.outline-transition {
  transition-duration: 0.3s;
  transition-property: border-color, color;
  transition-timing-function: ease;
}

.link-transition {
  transition-duration: 0.3s;
  transition-property: text-decoration, color;
  transition-timing-function: ease;
}
</style>
